module.exports = __webpack_public_path__ + "img/098efd0.svg";